<template>
  <div :key="$route.fullPath">
    <TopSection
      class="mb-3"
      :section="section"
      :title="$t('soundRecordingDetail')|capitalize"
      :sub-section="$t('soundrecordingDetail')|capitalize"
      :back-section="backSection"
    />
    <div
      v-on-clickaway="clickOutside"
      :class="`input-container ${this.results.length?'add-shadow':''}`"
    >
      <div class="relative">
        <input
          v-model="inputValue"
          placeholder="Search Sound Recordings"
          type="search"
          class="input-box"
          @input="debounce"
        >

        <div class="results-container">
          <div
            v-for="result in results"
            :key="result.id"
            class="sr-results"
            @click="navigateToSR(result.id)"
          >
            {{ result.artist }}
            {{ result.title?`, ${result.title}`:'' }}
          </div>
        </div>
      </div>
    </div>
    <RecordingDetails
      :title="soundRecording.title | capitalize"
      :artist="soundRecording.artist | capitalize"
      :extras="soundRecording.extras "
      :genres="soundRecording.genres"
      :duration="soundRecording.duration"
      :year="soundRecording.fixation_year"
      :type="soundRecording.type"
      :isrc="soundRecording.isrc"
      :fixation-country="soundRecording.fixation_country "
      :eligible="soundRecording.eligible"
      @toggleEligible="toggleEligible"
    />

    <SourceMetaDataTable v-if="soundRecording && soundRecording.id" />

    <ClaimsTable
      ref="table"
      v-if="soundRecording && soundRecording.id"
      :sound-recording="soundRecording"
      :sound-recording-id="soundRecording.id"
      :detailed="true"
    />
  </div>
</template>


<style lang="scss" scoped >
.title-column {
  width: 378px;
}

tbody tr td {
  padding: 0 !important;
}

.light-border-bottom {
  border-bottom: solid 2px rgba(0, 0, 0, 0.1);
}

.sr-results {
  display: flex;
  align-items: center;
  min-height: 50px;
  background-color: white;
  overflow: overlay;
  padding: 9px;
  min-width: 350px !important;
  color: gray;
  cursor: pointer;
}

.sr-results:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.results-container {
  box-shadow: 2px 2px 5px 2px;
  position: absolute;
  z-index: 10000000000000000000;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.input-container {
  position: fixed;
  z-index: 10000000;
  top: 9px;
}

.add-shadow {
  box-shadow: 2px 2px 5px 2px;
}

.input-box {
  width: 350px !important;
  height: 32px;
  background-color: white;
  border-radius: 4px;
  padding: 10px;
  color: gray;
}
</style>


<script>
import SourceMetaDataTable from "../../Modules/SourceMetaDataTable.vue"
import { api } from "@/main"
import { mixin as clickaway } from "vue-clickaway"
import { mapState } from "vuex"

export default {
  name: "SoundRecordingDetailPage",

  components: {
    SourceMetaDataTable
  },
  mixins: [clickaway],

  computed: {
    ...mapState("soundsys", ["dataReady"]),
    section () {
      switch (this.$route.name) {
      case "sound-recording-from-db-detail":
        return "Soundsys Database"
      case "sound-recording-from-usages-detail":
        return "Playlist Sheet"
      case "sound-recording-from-landed-detail":
        return "Landed Sound Recordings"
      }
      return "Soundsys Database"
    },
    backSection () {
      switch (this.$route.name) {
      case "sound-recording-from-db-detail":
        return "sound-recordings"
      case "sound-recording-from-usages-detail":
        return "usages"
      case "sound-recording-from-landed-detail":
        return "repertoire-files"
      }
      return "sound-recordings"
    }
  },
  methods: {
    toggleEligible () {
      api
        .put(`soundrecordings/${this.soundRecording.id}/eligibility/`, {
          eligible: !this.soundRecording.eligible
        })
        .then(() => {
          const { table } = this.$refs
          table.$refs.claimsTable.refresh()
        })
        .catch(err => { this.$toasted.global.toast(err) })
    },
    callApi (value) {
      api
        .get(`soundrecordings/?fuzzy_search=${value}&page=1`)
        .then(res => {
          const { get } = this.$options.filters
          const results = get(res, "data.results", [])
          if (!results.length) {
            this.results = [{ artist: "No results..." }]
          } else {
            this.results = results
          }
        })
        .catch(err => { this.$toasted.global.toast(err) })
    },
    navigateToSR (id) {
      this.$router.push({
        name: "sound-recording-from-db-detail",
        params: {
          id
        }
      })
      this.clickOutside()
    },
    clickOutside () {
      this.results = []
      this.inputValue = ""
    },
    debounce ({ target }) {
      const { value } = target
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (value.length > 2) {
          this.callApi(value)
        } else {
          this.results = []
        }
      }, 1000)
    }
  },
  data () {
    return {
      timeout: null,
      results: [],
      inputValue: "",
      soundRecording: {},
      prevRoute: null,
    }
  },
  async mounted (){
    let id = this.$route.params.id
    let url = `soundrecordings/${id}/`
    await api.get(url)
      .then(resp => {
        this.soundRecording = resp.data
      })

  }
}
</script>
